export enum ReportTableType {
  MCTMonitoring = 'Multi-catch mouse traps monitoring',
  SRBMMonitoring = 'Smart rodent bait modules monitoring',
  SRSTMonitoring = 'Snap traps (rat) monitoring',
  SMSTMonitoring = 'Snap traps (mouse) monitoring',
}
